import axios from 'axios'

export const state = {
  data: null
}

export const getters = {
  allAgreements: state => state.agreements
}

export const actions = {
  getAgreements ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('REQUEST_AGREEMENTS')
      axios.get('agreements').then(promise => {
        commit('RECEIVE_AGREEMENTS', promise.data.results)
        resolve()
      })
    })
  }
}

export const mutations = {
  RECEIVE_AGREEMENTS (state, agreements) {
    state.data = agreements
  },
  REQUEST_AGREEMENTS (state, payload) {
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
